//GeneratorFlag:[NoChange]
import Person from './person';

export default {Person}
export{Person}